/** Labels on a collection object (V2 Knowledge Base or V1 action bucket). */
export const getAgentCollectionLabels = collection =>
  collection?.collectionData?.labels ?? collection?.actionBucketData?.labels ?? [];

export const isV2KnowledgeCollection = collection => Boolean(collection?.collectionData);

export const getAgentCollectionStatus = collection =>
  collection?.collectionData?.status ?? collection?.actionBucketData?.status ?? null;

export const getAgentCollectionItemCounts = collection => {
  if (collection?.collectionData?.itemCounts) {
    return {
      pagesCount: collection.collectionData.itemCounts.url ?? 0,
      mediaCount: collection.collectionData.itemCounts.media ?? 0,
      totalCount: collection.collectionData.itemCounts.total ?? 0,
    };
  }

  return {
    pagesCount: collection?.actionBucketData?.pagesCount || 0,
    mediaCount: collection?.actionBucketData?.mediaCount || 0,
    totalCount:
      (collection?.actionBucketData?.pagesCount || 0) +
      (collection?.actionBucketData?.mediaCount || 0),
  };
};

/** V2 Knowledge Base collections that can be attached to a Knowledge Agent. */
export const isSelectableV2CollectionStatus = status =>
  status === 'ready' || status === 'completed';

export const getV2CollectionSelectBlockReason = status => {
  if (status === 'indexing') {
    return 'This collection is still indexing. Wait until it is ready before selecting it.';
  }
  if (status === 'failed') {
    return 'This collection failed indexing and cannot be selected.';
  }
  if (status === 'draft') {
    return 'This collection is still a draft. Finish indexing before selecting it.';
  }
  if (!isSelectableV2CollectionStatus(status)) {
    return 'Only ready collections can be selected.';
  }
  return null;
};
